import { useIsInDraftMode } from '@stores/data.store';
import React from 'react';

interface ObjectListHeaderProps {
    headerIcon?: React.ReactNode;
    title: string;
    subtitle?: string;
    actionButtonText?: string;
    actionButtonIcon?: string;
    actionButtonOnClick?: () => void;
    children?: React.ReactNode;
}

const ObjectListHeader: React.FC<ObjectListHeaderProps> = ({
    headerIcon,
    title,
    subtitle,
    actionButtonText,
    actionButtonIcon,
    actionButtonOnClick,
    children
}) => {
    const inDraftMode = useIsInDraftMode();
    return (
        <div className="source-header mb-2">
            <div className="d-flex center-vertically">
                {headerIcon && (
                    <div className="me-1">
                        {headerIcon}
                    </div>
                )}
                <h2 className="mb-0">{title}</h2>
                {subtitle && <>
                    <div className="ms-1 me-1">&bull;</div>
                    <div>{subtitle}</div>
                </>}
                
                {actionButtonText && actionButtonOnClick && inDraftMode && (<>
                
                    <div className="ms-1 me-1">&bull;</div>

                    <button 
                        className="btn btn-light btn-sm" 
                        onClick={actionButtonOnClick}
                    >
                        {actionButtonIcon && <i className={`mdi ${actionButtonIcon} me-1`}></i>}
                        {actionButtonText}
                    </button>
                </>)}
                <div className="flex-1">
                    
                </div>
                <div>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ObjectListHeader;